import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkAllError } from 'src/types/errors';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/parkings/:parkingId/membership-groups/:membershipGroupId/';

interface DTO {
    parkingId: string;
    membershipGroupId: number;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, membershipGroupId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { parkingId, membershipGroupId }));
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkAllError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteMembershipGroup };
